import React from "react";

import { HubContextMenu } from "../../components";
import BarcodePrintMenuItem from "./BarcodePrintMenuItem";

export const BarcodeContextMenu = ({
  id,
  test,
  includeDownload = true,
  getZplString = () => {},
  ...rest
}) => {
  const MENU_ITEMS = [
    includeDownload && {
      id: "download",
      label: test ? "Download Test Barcodes" : "Download Barcodes",
      icon: "Download",
    },
    {
      id: "delete",
      label: test ? "Delete Template" : "Delete Batch",
      icon: "Trash2",
      color: "redError",
    },
  ].filter(Boolean);

  const onSelect = (item) => {
    switch (item?.id) {
      case "download":
        window.print();
        break;
      case "print":
        break;
      case "delete":
        break;
      default:
        break;
    }
  };

  return (
    <HubContextMenu
      id={"barcode-template-details"}
      menuItems={MENU_ITEMS}
      onSelect={onSelect}
      IconButtonProps={{ sx: { margin: 0, padding: 0 } }}
      {...rest}
    >
      <BarcodePrintMenuItem getZplString={getZplString} test={test} />
    </HubContextMenu>
  );
};
export default BarcodeContextMenu;
